import { keysToSnakeCaseDeep } from '@agro1desenvolvimento/utils-js';
import aqilaApi from './aqila-api';

class Recomendacoes {
  private readonly endpoint = '/v1/recomendacoes';

  async rejeitar(id: number, motivo?: string) {
    await aqilaApi.patch(
      `${this.endpoint}/${id}`,
      keysToSnakeCaseDeep({
        recomendacao: {
          id,
          situacao: 'rejeitado',
          motivoRejeicao: motivo,
        },
      }),
    );
  }

  async aprovar(id: number) {
    await aqilaApi.patch(
      `${this.endpoint}/${id}`,
      keysToSnakeCaseDeep({
        recomendacao: {
          id,
          situacao: 'aprovado',
        },
      }),
    );
  }
}

export default new Recomendacoes();
